module.exports = __webpack_public_path__ + "static/kirti-14620dcdd2e3f83b44ae074d116f9159.jpg";